import SocialToolbar from "./layout/social-toolbar.js";
import {initSticky, recalcSticky} from "./layout/sticky-kit.js";
import {menusMobile, menusDesktop} from "./home/menus.js";
import {stickyHeaderDesktop, stickyHeaderMobile} from "./layout/sticky-header"
import sectionEventUtils from "../scripts/home/sectionLoadUtils";
import TeInteresa from "./article/te-interesa";
import {checkPushStatus, subscribeToChannels} from "./layout/push-notification-indigitall.js";
import initVamDebug from './layout/vam-debug.js';
import {notificationsLoad} from "./layout/vocuser-notifications"
import {checkInterest} from "./article/additionaldata-script";

Logger.debug('script layout loaded');

/** get main vars **************************************************************************/
const app = Voonto.getInstance();
const feature = window.nibara.feature;

const libPath = app.lookup('vocento.config.nibara').libPath;
if (libPath === undefined) {
  throw 'nibara libPath config is empty';
}

/** Menu absoluto abcblogs.abc.es **/
let host = window.location.host;
Logger.debug('[ABCBlogs] change path menu > host: ' + host);
if ('abcblogs.abc.es' === host) {
    Voonto.$('.primer-nivel li a').each(function() {
        var href = Voonto.$(this).attr('href');
        Logger.debug('[ABCBlogs] change path menu: ' + href);
        if (href.indexOf('https://') == -1 && href.indexOf('http://') == -1) {
            Voonto.$(this).attr('href','https://www.abc.es'+href);
        }
    });

    Voonto.$('.segundo-nivel li a').each(function() {
        var href = Voonto.$(this).attr('href');
        Logger.debug('[ABCBlogs] change path menu: ' + href);
        if (href.indexOf('https://') == -1 && href.indexOf('http://') == -1) {
            Voonto.$(this).attr('href','https://www.abc.es'+href);
        }
    });
}

/** btn up *********************************************************************************/
Voonto.$('.boton.subir.suave').click(function () {
  let target = Voonto.$('[name=top]');
  if (target) {
    Voonto.$('html,body').animate({
      scrollTop: target.offset().top
    }, 2000);
    return false;
  }
});

/** image lazyload **************************************************************************/
Voonto.lazyLoad = new LazyLoad({
  elements_selector: ".lzld",
  data_src: "src"
});

Voonto.$('.lzld-scroll').on('click', function (ev) {
  Voonto.lazyLoad.handleScroll();
});


/** Menus ***********************************************************************************/
if (Voonto.is.mobile()){
    Logger.info('Load menu mobile');
    menusMobile();
}else if( Voonto.is.tablet()) {
    if(vocento.tracking.comscore.voc_tc !== 'portada' && vocento.tracking.comscore.voc_tc !== 'portadilla') {
        Logger.info('Load menu mobile in news');
        menusMobile();
    }else{
        Logger.info('Load menu desktop in home');
        menusDesktop();
    }
} else {
    Logger.info('Load menu desktop in home');
    menusDesktop();
}

/** sticky header ***************************************************************************/
if (Voonto.is.mobile()) {
  stickyHeaderMobile();
} else {
  stickyHeaderDesktop();
}

if (Voonto.is.tablet()) {
  app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(() => {
    Voonto.$('[data-sticky]').stick_in_parent({
      offset_top: 20,
      spacer: false
    });
  });
}

/** tracking sticky mobile buttons ************************************************/
if (Voonto.is.mobile() || Voonto.is.tablet()) {
  Voonto.SocialToolbar = new SocialToolbar();
  var $stickyAds = Voonto.$('.publi-sticky');

  Voonto.$('.publi-sticky.sticky > .botones.cerrar').on('click', function () {
    Voonto.SocialToolbar.enable();
  });
  
  $stickyAds.on('click', function () {
    Voonto.$(this).hide();
  });

  /**
   * show Ads sticky when detect scroll
   * @type {boolean}
   */
  let delay = false;
  Voonto.$(window).on("scroll", function () {
    if (delay) return;
    
    delay = setTimeout(function () {
      if($stickyAds.attr('data-rendered') === 'true') {
        $stickyAds.show();
        $stickyAds.attr('data-rendered', false);
          /*if (document.location.href.indexOf("/cultura/") > -1 && 'noticia' === vocento.tracking.comscore.voc_tc) {
              setTimeout(function () {
                  Voonto.$('.publi-sticky.sticky > .botones.cerrar').click();
              }, 3000);
          }*/
      }
      delay = false;
    }, 50);
  });

} else {
  if (vocento.tracking.comscore.voc_tc !== 'portada' && vocento.tracking.comscore.voc_tc !== 'portadilla') {
    app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(() => {
      Voonto.$('[data-sticky]').stick_in_parent({
        offset_top: 20,
        spacer: false
      });
    });

    initSticky();

    Voonto.$(window).on('resize', function () {
      Logger.info('[Sticky] Window Resize');
      recalcSticky();
    });

    Voonto.$('[data-voc-vam]').on('vam:viewable', function () {
      Logger.info('[Sticky] Banner', Voonto.$(this), 'viewable');
      recalcSticky();
    });

    app.on('layout:init-sticky', function () {
      initSticky();
    });

    app.on('layout:recalc-sticky', function () {
      recalcSticky();
    });

    document.addEventListener('scroll', nibara.nTools.throttle(200, function () {
      recalcSticky();
    }));
  }
}


/** VocUser **********************************************************************/
const vocUserPath = app.lookup('vocento.config.nibara').vocUserPath;
if (vocUserPath === undefined) {
  throw 'vocUserPath path in config is empty';
}
const vocUserVersion = app.lookup('vocento.config.nibara').vocUserVersion;
if (vocUserVersion === undefined) {
  throw 'vocuser version is empty';
}
Logger.info('Loading vocuser version: ' + vocUserVersion);
app.load(vocUserPath + '/vocento-vocuser-preloader.js?v=' + vocUserVersion);


/** Comments */
const commentsPath = app.lookup('vocento.config.nibara').commentsPath;
Logger.info('Loading comments version: ' + commentsPath);
if (commentsPath === undefined) {
    throw 'commentsPath path in config is empty';
}

app.when('vocuser:gigyaready').then(function (e) {
    app.load(commentsPath + '/comments.js');
});

/** Vam **************************************************************************/

if (feature.homeBacktrace && Voonto.$('body').data('seccion') === 'portada' && window.nibara.isBack === true) {

  if(history.state.section === 'main' && typeof history.state.scrollTop !== 'undefined' && history.state.scrollTop > Voonto.$('[data-section="main"]').height()) {
    sectionEventUtils.disableHomeTopAds();
  }
  if(history.state.lastSectionView !== 'main') {
    sectionEventUtils.disableHomeTopAds();
  }
}

if (window.location.search.indexOf('nDebug_vam=1') > 0) {
  initVamDebug(app);
} else {
  const vamPath = app.lookup('vocento.config.nibara').vamPath;
  if (vamPath === undefined) {
    throw 'nibara vamPath config is empty';
  }
  let vamUrl = `${vamPath}/vam.js`;
  Logger.info('Loading vam version: ' + vamUrl);

  app.load(vamUrl);  
}

/** Vam empty position autohide ***************************************************/
Voonto.$('[data-voc-vam]').on('vam:isempty', function () {
  if($(this).parent().hasClass('publicidad-portada')) {
    Logger.info('[VAM] Ad slot is empty, hide position: ' + Voonto.$(this).data('voc-vam-position'));
    Voonto.$(this).hide();
    Voonto.$(this).parent().hide();
  }
});

Voonto.getInstance().when('vam:apiready').then((vamApi) => {
    const adsContainer = [...document.querySelectorAll('[data-voc-vam]')];
    adsContainer.forEach((element) => {
        vamApi.isPositionInactive({ position: `${element.dataset.vocVamPosition}-id` })
            .then((inactive) => {
                if (inactive) {
                    Logger.info('[VAM] Ad slot is inactive, hide position: ' + Voonto.$(element).data('voc-vam-position'));
                    Voonto.$(this).hide();
                    Voonto.$(this).parent().hide();
                }
            })
    });
});


/** header search widget *********************************************************/
let $formsBusqueda = Voonto.$(".buscador-cabecera, nav.navegacion form.buscador");

$formsBusqueda.on("submit", function (e) {
  e.preventDefault();
  e.stopPropagation();
  
  Logger.info('Buscador cabecera');
  
  let str = Voonto.$(this).find('input').val();
  let location = '/hemeroteca/';
  
  if (str.length > 0) {
    str = window.nibara.nTools.kebabCase(str);
    if (window.location.href.indexOf('lavozdigital.es') > -1) {
      location += 'noticias/';
      str += '.html';
    }
    location += str;
  }
  
  Logger.debug('Buscador action: ', location);
  window.location.href = location;

  return false;
});

$formsBusqueda.find('input').on('keypress', function(e) {  
  if(e.which === 13) {    
    let $parentForm = Voonto.$(this).closest('form');
    Logger.info('Buscador keypress Enter -> trigger submit form.' . $parentForm.attr('class'));
    $parentForm.trigger('submit');
  }
});


/** cookie law (deprecated) ***/
if (feature.cookieLaw) {
  Logger.debug("feature cookieLaw active");
  function createCookieLaw() {
    if (document.cookie.indexOf("cookie_20170731") === -1) {
      let cookieName = 'cookie_20170731';
      Logger.info('[Cookie Layer] createCookieLaw: ' + cookieName);
      let cookieDate = new Date;
      cookieDate.setFullYear(cookieDate.getFullYear() + 1);
      document.cookie = cookieName + '=visited; expires=' + cookieDate.toGMTString() + ';';
      Voonto.$('.capa-cookies').fadeOut().hide();
    }
  }

  function checkCookieLaw() {
    Logger.info('[Cookie Layer] checkCookieLaw');
    if (document.cookie.indexOf("cookie_20170731") === -1) {
      let cookieDiv = $('.capa-cookies');
      cookieDiv.show();

      Voonto.$(window).one('mousewheel', function (e) {
        Logger.info('[Cookie Layer] create cookie mousewheel');
        createCookieLaw();
      });

      Voonto.$(window).one('scroll', function (e) {
        Logger.info('[Cookie Layer] create cookie scroll');
        createCookieLaw();
      });

      Voonto.$(window).one('touchmove', function (e) {
        Logger.info('[Cookie Layer] create cookie touchmove');
        createCookieLaw();
      });

      cookieDiv.click(function () {
        Logger.info('[Cookie Layer] create cookie click');
        createCookieLaw();
      });
    }
  }
}

/** Push notifications Indigitall ************************************************************/
document.addEventListener('indigitallReady', function() {
    let defaultChannels = [];
    let domainPush = 'push.abc.es';
    if (document.URL.indexOf('sevilla.abc.es') > -1) {
        domainPush = 'push-sevilla.abc.es';
    } else if (document.URL.indexOf('.lavozdigital.es') > -1) {
        domainPush = 'push.lavozdigital.es';
    }
    let url = "https://" + domainPush + "/pushStatusChecker.html?v=1";

    checkPushStatus(url, function(response) {
        Logger.debug(domainPush + ' enabled: ' + response.permission);
        if (!response.permission) {
            let oldState = window.Notification.permission;
            navigator.indigitall.loadIndigitall(function(){
                let newState = window.Notification.permission;
                if(newState != oldState && newState == 'granted' && Array.isArray(defaultChannels) && defaultChannels.length > 0){
                    subscribeToChannels(defaultChannels);
                }
            });
        } else {
            navigator.indigitall.loadIndigitall(function(){
                if(Array.isArray(response.channels) && response.channels.length > 0){
                    subscribeToChannels(response.channels);
                }else if(Array.isArray(defaultChannels) && defaultChannels.length > 0){
                    subscribeToChannels(defaultChannels);
                }
            });
        }
    });
});

app.load('/indigitall/indigitall.min.js?v=20190218');

/** create cookie function *******************************************************/
function createCookie(src, content = '') {
  Logger.info('[Breaking News] Creo una cookie para un tiempo de vida de 1 hora.');
  // Creo una cookie para un tiempo de vida de 1 hora.
  let date = new Date();
  let minutes = 60;
  date.setTime(date.getTime() + (minutes * 60 * 1000));

  let cookieParameters = {path: '/', expires: date};
  Cookies(src, content, cookieParameters);
}

function compruebaCookie() {
  Logger.info('[Breaking News] compruebaCookie');
  let src = 'BreakingNews-ABC';
  Logger.info('[Breaking News] src: ' + src);
  return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
}

/** sticky breaking-news|social|ads *********************************************************/
if (feature.breakingNews && (Voonto.is.mobile() || Voonto.is.tablet())) {

  let $urgente = Voonto.$('.urgente-teinteresa');
  if ($urgente.length > 0) {
    let $cerrarUrgente = $urgente.find('.cerrar');
    let type = $cerrarUrgente.data('type');
    if (type === 'urgente') {
      if (compruebaCookie()) {
        Logger.info('[Breaking News] urgente hide. Existe cookie');
        $urgente.hide();
      } else {
        Logger.info('[Breaking News] urgente show. No existe cookie');
        $urgente.show();
      }
    } else {
      Logger.info('[Breaking News] urgente show. Existe urgente multiple');
      $urgente.show();
    }

    $cerrarUrgente.click(() => {
      $urgente.hide();
      Voonto.SocialToolbar.enable();

      let type = $cerrarUrgente.data('type');
      if (type === 'te-interesa') {
        return false;
      }

      let src = 'BreakingNews-ABC';
      let content = 'Breaking News - ABC';
      createCookie(src, content);
    });
  }

  Voonto.$('.noticia').click(function () {
    Logger.info('[Breaking News] click noticia');
    let type = Voonto.$(this).data('type');
    if (type === 'urgente') {
      let src = 'BreakingNews-ABC';
      let content = 'Breaking News - ABC';
      createCookie(src, content);
    }

    Logger.info('[Breaking News] type: ', type);

    let href = Voonto.$(this).data('href');
    if (typeof href !== 'undefined') {
      Logger.info('[Breaking News] href: ', href);
      window.location.href = href;
    }
  });
}


/** sticky teInteresa|ads ***************************************************/
if (feature.teInteresa && (Voonto.is.mobile() || Voonto.is.tablet())) {
  Logger.debug("feature teInteresa active");

  $stickyAds.find('[data-voc-vam]').on('vam:isempty', function () {
    Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is empty');
    let $urgente = Voonto.$('.urgente-teinteresa');
    let showTeInteresa = true;
    if ($urgente.length > 0) {
      let $cerrarUrgente = $urgente.find('.cerrar');
      let type = $cerrarUrgente.data('type');
      if (type === 'urgente') {
        if (compruebaCookie()) {
          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
        } else {
          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
          showTeInteresa = false;
        }
      } else {
        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
        showTeInteresa = false;
      }
    }

    if (!showTeInteresa) {
      Logger.info('BreakingNews ad slot is empty but exist urgente');
      $stickyAds.hide();
    } else {
      if(Voonto.$('body').data('seccion') !== 'portada') {
        Logger.info('BreakingNews ad slot is empty');
        $stickyAds.hide();
        let teinteresa = new TeInteresa();
        teinteresa.load(Voonto.$('#breaking-news-container'));
      }
    }
  });

  $stickyAds.find('[data-voc-vam]').on('vam:inactive', function () {
    Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is inactive');
    let $urgente = Voonto.$('.urgente-teinteresa');
    let showTeInteresa = true;
    if ($urgente.length > 0) {
      let $cerrarUrgente = $urgente.find('.cerrar');
      let type = $cerrarUrgente.data('type');
      if (type === 'urgente') {
        if (compruebaCookie()) {
          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
        } else {
          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
          showTeInteresa = false;
        }
      } else {
        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
        showTeInteresa = false;
      }
    }

    if (!showTeInteresa) {
      Logger.info('BreakingNews ad slot is inactive but exist urgente');
      $stickyAds.hide();
    } else {
      if(Voonto.$('body').data('seccion') !== 'portada') {
        Logger.info('BreakingNews ad slot is inactive');
        $stickyAds.hide();
        let teinteresa = new TeInteresa();
        teinteresa.load(Voonto.$('#breaking-news-container'));
      }
    }
  });

  $stickyAds.find('[data-voc-vam]').on('vam:slotrendered', function () {
    let $urgente = Voonto.$('.urgente-teinteresa');
    let showTeInteresa = true;
    if ($urgente.length > 0) {
      let $cerrarUrgente = $urgente.find('.cerrar');
      let type = $cerrarUrgente.data('type');
      if (type === 'urgente') {
        if (compruebaCookie()) {
          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
        } else {
          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
          showTeInteresa = false;
        }
      } else {
        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
        showTeInteresa = false;
      }
    }

    if (!showTeInteresa) {
      Logger.info('[data-voc-vam][Breaking News] ad slot is active but exist urgente');
      $stickyAds.hide();
    } else {
      Logger.info('[data-voc-vam][Breaking News] ad slot is active');
      $stickyAds.attr('data-rendered', true);
    }
  });

  /**
   * show Ads sticky when detect scroll
   * @type {boolean}
   */
  let delay = false;
  Voonto.$(window).on("scroll", function () {
    if (delay) return;
    
    delay = setTimeout(function () {
      if($stickyAds.attr('data-rendered') === 'true') {
          $stickyAds.show();
          $stickyAds.attr('data-rendered', false);
          if (document.location.href.indexOf("/cultura/") > -1 && 'noticia' === vocento.tracking.comscore.voc_tc) {
              setTimeout(function () {
                  Voonto.$('.publi-sticky.sticky > .botones.cerrar').click();
              }, 3000);
          }
      }
      delay = false;
    }, 50);
  });

  $stickyAds.on('click', function () {
    Voonto.$(this).hide();
  });
}

// Comportamiento para cerrar el menu de compartir cuando se hace scroll
if (feature.shareLayer) {
  Logger.debug("feature shareLayer active");
  let inputShareLayer = Voonto.$('input#capa_compartir'),
    labelShareLayer = Voonto.$('label[for="capa_compartir"]'),
    inputFixedLayer = Voonto.$('input#capa_compartir_fija'),
    labelFixedLayer = Voonto.$('label[for="capa_compartir_fija"]'),
    containerShareLayer = Voonto.$('aside.herramientas:not(.fija) .mas-compartir'),
    containerShareFixedLayer = Voonto.$('aside.herramientas.fija .mas-compartir');

  let closeShareLayerHandler = () => {
    Logger.info('[CloseShareLayerHandler] scrolled');

    if (inputShareLayer.prop('checked') === true) {
      inputShareLayer.prop('checked', false);
      Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
    }

    Voonto.$(window).unbind('scroll', this);
    Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);

  };

  let closeFixedShareLayerHandler = () => {
    Logger.info('[CloseFixedShareLayerHandler] scrolled');

    if (inputFixedLayer.prop('checked') === true) {
      inputFixedLayer.prop('checked', false);
      Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
    }

    Voonto.$(window).unbind('scroll', this);
    Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
  };

  let closeClickDocumentShareLayerHandler = (e) => {
    Logger.info('[CloseShareLayerHandler] document onclick');

    if (inputShareLayer.prop('checked') === true) {
      // esta abierto el menu compartir
      if (Voonto.$.contains(containerShareLayer.get(0), e.target) === false
          && Voonto.$.contains(labelShareLayer.get(0), e.target) === false) {
        inputShareLayer.prop('checked', false);
        Voonto.$(document).unbind('click', this);
        Voonto.$(window).unbind('scroll', closeShareLayerHandler);
        Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
      }
    }

    if (inputFixedLayer.prop('checked') === true) {
      // esta abierto el menu compartir de la barra fija
      if (Voonto.$.contains(containerShareFixedLayer.get(0), e.target) === false
          && Voonto.$.contains(labelFixedLayer.get(0), e.target) === false) {
        inputFixedLayer.prop('checked', false);
        Voonto.$(document).unbind('click', this);
        Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
        Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
      }
    }
  };

  inputShareLayer.on('change', function () {
    let $this = Voonto.$(this);
    Logger.info('[CloseShareLayerHandler] input change');
    if ($this.prop('checked') === true) {
      Voonto.$(document)
        .unbind('click', closeClickDocumentShareLayerHandler)
        .on('click', closeClickDocumentShareLayerHandler);
    } else {
      Voonto.$(window).unbind('scroll', closeShareLayerHandler);
      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
    }
  });

  inputFixedLayer.on('change', function () {
    let $this = Voonto.$(this);
    Logger.info('[CloseFixedShareLayerHandler] input change');
    if ($this.prop('checked') === true) {
      Voonto.$(window).one('scroll', closeFixedShareLayerHandler);
      Voonto.$(document)
        .unbind('click', closeClickDocumentShareLayerHandler)
        .on('click', closeClickDocumentShareLayerHandler);
    } else {
      Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
    }
  });
}

/*************** Notificaciones MiABC y Popup datos adicionales *******************/
app.when('vocuser:ready').then((gigyaUX) => {
    Logger.debug('[vocuser-ready] gigyaUX',gigyaUX);
    let userType = gigyaUX.getUserType();
    if (userType !== 'anonimo') {
        Logger.debug('[vocuser-ready] usuario logado',gigyaUX);
        notificationsLoad();
        checkInterest();
    }
});



// WEBPACK FOOTER //
// ./src/scripts/layout-script.js